import { useState } from 'react';
import MobileOrDesktopDialog from '../mobileOrDesktopDialog';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import CallIcon from '@/assets/Icons/Call.svg';
import { useSelector } from 'react-redux';

const IVRData = {
    service_advisor_number: '18002669293',
    service_advisor_name: 'Acko Drive',
};
const Help = ({ show, onClose }: any) => {
    const data = useSelector(
        (state: any) =>
            state.garage?.timeline?.latest_stage_details?.common_details || {}
    );
    const {
        service_advisor_number = '18002669293',
        service_advisor_name = 'Acko Drive Service Center',
    } = data || {};
    return (
        <MobileOrDesktopDialog
            show={show}
            onClose={() => onClose(false)}
            isMobile
        >
            <>
                {' '}
                <p className="title">Help</p>
                <p className="helper-text">
                    In case of any queries ,you may reach out to the service
                    advisor
                </p>
                <div className="help">
                    <div>
                        <span className="advisor">Service Advisor</span>
                        <div className="name">
                            {service_advisor_name ||
                                IVRData.service_advisor_name}
                        </div>
                    </div>
                    <a
                        href={`tel:${
                            service_advisor_number ||
                            IVRData.service_advisor_number
                        }`}
                        className="call"
                    >
                        <DarkButton size="small">
                            <CallIcon />
                            Call
                        </DarkButton>
                    </a>
                </div>
                <style jsx>{`
                    .title {
                        color: #040222;
                        font-size: 18px;
                        font-weight: 600;
                        line-height: 24px;
                    }
                    .helper-text {
                        font-size: 14px;
                        font-weight: 500;
                    }
                    .help {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-radius: 10px;
                        background-color: #fff;
                        box-shadow: 0px 5px 50px rgba(219, 227, 246, 0.31);
                        border: 1px solid #e0e0e8;
                        padding: 16px 20px;
                        margin-bottom: 20px;
                    }
                    .advisor {
                        color: #5b5675;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                    }
                    .name {
                        color: #040222;
                        font-size: 14px;
                        font-weight: 600;
                        line-height: 20px;
                    }
                    .call {
                        button {
                            display: flex;
                            gap: 5px;
                        }
                        text-decoration: none;
                        cursor: pointer;
                    }
                `}</style>
            </>
        </MobileOrDesktopDialog>
    );
};

export default Help;
